<template>
  <div>
    <div :class="containerClass" :style="{ marginBottom: isMobileScreen ? '80px' : '' }">
      <div class="d-flex flex-column flex-sm-row align-items-sm-center mb-24pt mt-4" style="white-space: nowrap">
        <h2 class="mb-0 d-sm-block" v-if="!isMobileScreen">
          My Skill Cards
          <i class="material-icons icon-16pt clickable-item" v-b-popover.hover.top="'Explore you own skill cards.'"
            >info</i
          >
        </h2>
        <h2 class="mb-2 d-sm-block" v-if="isMobileScreen" style="align-self: center;">
          My Skill Cards
          <i class="material-icons icon-16pt clickable-item" v-b-popover.hover.top="'Explore you own skill cards.'"
            >info</i
          >
        </h2>
        <div class="w-auto ml-sm-auto mb-sm-0 justify-content-end">
          <b-btn
            variant="secondary"
            :style="{
              width: isMobileScreen ? '100%' : '190px',
              marginTop: isMobileScreen ? '20px' : '',
              backgroundColor: get(getLoggedInUser, 'linked_entity.primary_color'),
              border: 'none',
            }"
            type="submit"
            class=" btn-normal"
            @click.prevent="goToCreateSkillCard"
          >
            <i class="material-icons mr-1">add</i>Create Skillcard
          </b-btn>
        </div>
      </div>

      <page-separator
        :title="
          !isLoading
            ? `showing ${totalSkillCards ? `${pageFromCount}-${pageToCount}` : 0} of ${totalSkillCards} Skill Cards`
            : ''
        "
      />

      <div class="page-section d-flex justify-content-center" v-if="!skillCard.length && !isLoading">
        <div class="card card-block card-stretch card-height col-md-8">
          <div class="card-body text-center">
            <i class="fas fa-exclamation-circle fa-lg text-muted mt-4 mb-4" style="font-size: 3rem" />
            <h4>No Skill Cards Found</h4>

            <p class="text-muted">
              Couldn't find any skill cards. Publish your skill cards practice skills now and showcase your CNA
              skills!
            </p>
          </div>
        </div>
      </div>

      <b-skeleton-wrapper :loading="isLoading" v-else>
        <template #loading>
          <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-6" v-for="item in [1, 2, 3]" :key="item">
              <div class="card card-sm card--elevated p-relative">
                <span class="js-image">
                  <b-skeleton-img width="100%" class="pb-0 mb-0"></b-skeleton-img>
                </span>

                <div class="card-body">
                  <div class="d-flex">
                    <span class="ml-2 w-100">
                      <div class="card-title"><b-skeleton width="100%" /></div>
                      <div class="text-muted"><b-skeleton width="50%"></b-skeleton></div>
                    </span>
                  </div>
                </div>
                <div class="">
                  <div class="row justify-content-center mr-2 mb-2">
                    <b-skeleton width="80%" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div class="row">
          <div
            v-for="(card, index) in skillCard"
            :key="card.id"
            :id="`skill-${card.id}`"
            class="col-lg-4 col-md-4 col-sm-6 clickable-item"
            :style="{ marginBottom: isMobileScreen ? '25px' : '40px' }"
          >
            <div style="height: 310px; margin-bottom: 10px;">
              <div
                class="card"
                @click="openModal(card)"
                @mouseenter="handleMouse(index)"
                @mouseleave="handleMouse(index)"
              >
                <div class="card-image">
                  <img
                    :src="card.image ? card.image : require('@/assets/images/placeholders/default_image.jpeg')"
                    :alt="title"
                  />
                  <div class="hover-overlay" :class="{ active: showHover[index] }">
                    <div class="hover-content">
                      <i class="fas fa-eye clickable-item ml-2 eye-icon"></i>
                      <span>View Details</span>
                    </div>
                  </div>
                </div>

                <div class="card-content">
                  <div>
                    <h3 class="card-title">
                      {{ card.skillmap.length > 25 ? card.skillmap.slice(0, 25) + '...' : card.skillmap }}
                    </h3>
                  </div>
                  <div>
                    <div class="card-stats">
                      <div class="precision" v-if="card.precision !== null">
                        <i class="fas fa-solid fa-bullseye mr-1"></i>

                        <span>Precision: {{ card.precision }}%</span>
                      </div>

                      <div v-if="card.status" class="status" :style="{ color: getStatusColor(card.status) }">
                        <i class="material-icons icon-16pt mr-1 flex-shrink-0" v-if="card.status === 'pending'"
                          >schedule</i
                        >
                        <i class="material-icons icon-16pt mr-1 flex-shrink-0" v-else-if="card.status === 'approved'"
                          >check_circle</i
                        >
                        <i class="material-icons icon-16pt mr-1 flex-shrink-0" v-else-if="card.status === 'rejected'"
                          >cancel</i
                        >

                        <span>{{ STATUSES[card.status] }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="px-3 pb-3 pt-1">
                  <button class="view-details-btn" type="button">
                    <md-icon class="mr-1">list</md-icon>
                    View Details
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-skeleton-wrapper>
      <skill-card-result-modal
        :is-open="showSkillCardModal"
        @hide-modal="showSkillCardModal = false"
        :card="currentCard"
      />
      <pagination
        v-if="totalSkillCards > skillCard.length"
        v-model="currentPage"
        :total-rows="totalSkillCards"
        :per-page="perPage"
        @change="onPageChange"
        class="mb-3"
        :style="{ marginTop: isMobileScreen ? '15px' : '' }"
      />
    </div>
  </div>
</template>

<script>
import Page from '@/components/Page.vue';
import Pagination from '../../../components/Ui/Pagination.vue';
import { get, debounce } from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import { formatTime } from '../../../common/utils';
import PageSeparator from '@/components/Ui/PageSeparator.vue';
import SkillCardResultModal from '@/components/SkillCard/SkillCardResultModal.vue';

export default {
  components: {
    Pagination,
    PageSeparator,
    SkillCardResultModal,
  },
  extends: Page,

  data() {
    return {
      title: 'Skill Cards',
      currentCard: {},
      skillmap: '',
      totalSkillCards: 0,
      skillCard: [],
      isLoading: false,
      perPage: 16,
      onfirstLoad: true,
      showHover: [],
      STATUSES: { pending: 'Pending', approved: 'Approved', rejected: 'Not Approved' },
      showSkillCardModal: false,
    };
  },

  computed: {
    ...mapGetters('auth', ['getLoggedInUser']),

    breadcrumb() {
      return [
        { text: this.$t('home'), to: this.routes.home },
        { text: 'Skills', active: true },
      ];
    },
    isMobileScreen() {
      return window.innerWidth < 768;
    },
  },
  watch: {
    skillmap: {
      deep: true,
      handler() {
        this.debouncedSearchSkillCards(this);
        setTimeout(() => {
          this.onfirstLoad = false;
        }, 500);
      },
    },
  },

  methods: {
    ...mapActions('aiSkills', ['getMySkillCards']),

    formatTime,
    get,

    debouncedSearchSkillCards: debounce(vm => {
      vm.fetchAiSkillmapCards();
    }, 500),
    handleMouse(index) {
      this.$set(this.showHover, index, !this.showHover[index]);
    },

    getStatusColor(status) {
      if (status === 'approved') {
        return 'green';
      } else if (status === 'rejected') {
        return 'red';
      } else {
        return 'orange';
      }
    },
    goToCreateSkillCard() {
      this.$router.push({ name: 'student-create-skillmap' });
    },

    openModal(card) {
      this.currentCard = card;
      this.showSkillCardModal = true;
    },
    hideModal() {
      this.showSkillCardModal = false;
    },

    async fetchAiSkillmapCards(pageNum = 1, params = {}) {
      this.isLoading = true;
      document.getElementById('app').scrollIntoView();
      try {
        const response = await this.getMySkillCards({
          limit: this.perPage,
          offset: (pageNum - 1) * this.perPage,
          student__user__id: this.getLoggedInUser.id,
          ...(this.ordering && { ordering: this.ordering }),
          ...(this.skillmap ? { skill_map__id: this.skillmap } : {}),
          ...params,
        });
        this.skillCard = response.data.results;

        this.currentPage = pageNum;
        this.totalSkillCards = response.data.count;
        this.pageFromCount = (this.currentPage - 1) * this.perPage + 1;
        this.pageToCount = this.pageFromCount + get(response.data, 'results.length', 0) - 1;
      } catch (err) {
        this.makeToast({ variant: 'danger', msg: this.$t('generalMsgs.genErrorMsg') });
      }
      this.isLoading = false;
    },

    onPageChange(pageNum) {
      this.fetchAiSkillmapCards(pageNum);
    },

    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  async mounted() {
    window.addEventListener('resize', this.handleResize);
    await this.fetchAiSkillmapCards();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style scoped>
.card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #e5e7eb;
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.card-image {
  position: relative;
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.card:hover .card-image img {
  transform: scale(1.05);
}

.hover-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.hover-overlay.active {
  opacity: 1;
}

.hover-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  text-align: center;
}

.eye-icon {
  font-size: 32px;
  margin-bottom: 5px;
}

.hover-content span {
  font-size: 16px;
  font-weight: 600;
}

.card-content {
  padding: 16px;
  padding-bottom: 0px;
}

.card-title {
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 5px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.card-stats {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.precision {
  display: flex;
  align-items: center;
  color: deepskyblue;
  font-size: 14px;
  font-weight: 500;
}

.status {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  padding: 4px 0px;
  border-radius: 6px;
}

.view-details-btn {
  width: 100%;
  background: white;
  border: 1px solid #e2e8f0;
  color: #64748b;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.view-details-btn:hover {
  background: #f8fafc;
  border-color: #f8fafc;
}

@media (max-width: 767.98px) {
  .card {
    margin-bottom: 0.5rem;
  }
  .card-body {
    padding: 0.75rem;
  }

  .card-title {
    font-size: 0.9rem;
  }

  .text-muted {
    font-size: 0.8rem;
  }
}
</style>
